import { localizationService } from '@shared-services/localization-service';
import { CheckboxLimitations } from 'client/widget-components/ecom/stores/types';

const { str } = localizationService;

interface ChoicesLimitMessageArgs {
    limitations?: CheckboxLimitations;
    /** Total selected units, i.e. the length of the checkbox value multiset. */
    selectedCount: number;
}

export const getChoicesLimitMessage = ({
    limitations,
    selectedCount,
}: ChoicesLimitMessageArgs): string | null => {
    const min = limitations?.min_choices || 0;
    const max = limitations?.max_choices || 0;

    if ((!min && !max) || selectedCount <= 0) {
        return null;
    }

    if (max && selectedCount >= max) {
        return str(
            'ui.runtimessr.productCustomizations.checkbox.hint.maxReached'
        );
    }

    if (min && max) {
        return min === max
            ? str(
                  'ui.runtimessr.productCustomizations.checkbox.hint.exactly',
                  { exact: min.toString() }
              )
            : str('ui.runtimessr.productCustomizations.checkbox.hint.range', {
                  min: min.toString(),
                  max: max.toString(),
              });
    }

    if (min) {
        return str('ui.runtimessr.productCustomizations.checkbox.hint.min', {
            min: min.toString(),
        });
    }

    return str('ui.runtimessr.productCustomizations.checkbox.hint.max', {
        max: max.toString(),
    });
};
